var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCellPhoneAppTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "90px",
    height: "90px",
    viewBox: "0 0 90 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0_4_Icons_MIB3 / 0_4_3_IconMaster / home / cell_phone_app_tile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515151",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "41.5237107%",
    x2: "55.7322669%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.5,
    offset: "34.965035%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0.5,
    offset: "54.7967657%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 5,
    y: 12,
    width: 43,
    height: 63
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-4",
    x: 5,
    y: 12,
    width: 43,
    height: 63
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "0_4_Icons_MIB3-/-0_4_3_IconMaster-/-home-/-cell_phone_app_tile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DeviceManager",
    transform: "translate(19.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53,4 C53,1.79 51.1755769,-2.74974354e-09 48.9230769,-2.74974354e-09 L4.07692308,-2.74974354e-09 C1.82442308,-2.74974354e-09 1.20962795e-10,1.79 1.20962795e-10,4 L1.20962795e-10,84 C1.20962795e-10,86.2100002 1.82442308,88 4.07692308,88 L48.9230769,88 C51.1755769,88 53,86.2100002 53,84 L53,4 Z",
    id: "Device---Fill",
    fill: "#E6E6E6",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9230769,0.499999997 C49.9123083,0.499999997 50.8079802,0.892306798 51.4560556,1.52815438 C52.100652,2.16058858 52.5,3.03419852 52.5,4 L52.5,4 L52.5,84 C52.5,84.9658015 52.1006521,85.8394115 51.4560557,86.4718456 C50.8079803,87.1076932 49.9123084,87.5 48.9230769,87.5 L48.9230769,87.5 L4.07692308,87.5 C3.08769163,87.5 2.19201975,87.1076932 1.54394433,86.4718456 C0.899347946,85.8394115 0.5,84.9658015 0.5,84 L0.5,84 L0.5,4 C0.5,3.03419852 0.89934797,2.16058858 1.54394438,1.52815438 C2.19201979,0.892306798 3.08769165,0.499999997 4.07692308,0.499999997 L4.07692308,0.499999997 Z",
    id: "Device---Border",
    strokeOpacity: 0.5,
    stroke: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Buttom---Fill",
    fill: "#000000",
    x: 20,
    y: 79.5,
    width: 13,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Buttom---Border",
    stroke: "#FFFFFF",
    x: 20,
    y: 79.5,
    width: 13,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Screen---Fill"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fillOpacity: 0.03,
    fill: "url(#linearGradient-2)",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Screen---Border"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeOpacity: 0.5,
    stroke: "#FFFFFF",
    x: 4.5,
    y: 11.5,
    width: 44,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#000000",
    strokeLinejoin: "square",
    x: 5.5,
    y: 12.5,
    width: 42,
    height: 62
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellPhoneAppTile);
export default __webpack_public_path__ + "static/media/cell_phone_app_tile.9c30d2d99049c4a6e25608f9fb9d28a0.svg";
export { ForwardRef as ReactComponent };